import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { SelectionModel } from "@angular/cdk/collections";
import {
  Component,
  ElementRef,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
  Input,
} from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { Sort } from "@angular/material/sort";
import { MatDialog } from "@angular/material/dialog";
import { Router, RouterLink } from "@angular/router";
import { CommissionService } from "src/app/iap/services/commission.service";
import { DialogService } from "src/app/iap/services/dialog.service";
import { UserService } from "src/app/iap/services/user.service";
import { AuthenticationService } from "src/app/shared/auth/auth.service";
import { DisputedRequestComponent } from "../disputed-requests/disputed-request.component";
import { EventEmitter } from "@angular/core";

import { Workbook } from "exceljs";
import * as fs from "file-saver";

import htmlToPdfmake from "html-to-pdfmake";
//import { LoadedRouterConfig } from "@angular/router/src/config";
import { Subject } from "rxjs";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
} from "@angular/forms";
import { MatFormFieldModule, MatLabel } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MatInputModule } from "@angular/material/input";
import { CommonModule } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { MatCheckbox } from "@angular/material/checkbox";
import { MatTabsModule } from "@angular/material/tabs";

pdfMake.vfs = pdfFonts?.vfs;

export class EventComponent {
  term: string;
}

@Component({
    selector: "app-claims-table",
    templateUrl: "./claims-table.component.html",
    styleUrls: ["./claims-table.component.scss"],
    imports: [
        MatFormFieldModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatTableModule,
        MatPaginator,
        MatInputModule,
        CommonModule,
        MatIconModule,
        MatButtonModule,
        MatCheckbox,
        MatTabsModule,
        MatLabel,
    ],
    animations: [
        trigger("detailExpand", [
            state("collapsed, void", style({ height: "0px" })),
            state("expanded", style({ height: "*" })),
            transition("expanded <=> collapsed", animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")),
            transition("expanded <=> void", animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")),
        ]),
    ]
})
export class ClaimsTableComponent implements OnInit, OnChanges {
  ELEMENT_DATA: any[];
  @Input() commissionsLocked: boolean;
  @Input() commissionsLockedMessage: string;

  displayedColumns: string[] = [
    "select",
    "StudentName",
    "SENECA_ID",
    "ApplicationID",
    "Term",
    "AgentName",
    "StatusDate",
    "TuitionAmount",
    "CommissionAmount",
    "CommissionStatusName",
    "Dispute",
  ];

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @ViewChild("pdfTable") pdfTable: ElementRef;
  @Output() eventClick: EventEmitter<any> = new EventEmitter();

  dataSource: MatTableDataSource<any>;
  dataSourceLoaded: MatTableDataSource<any>;
  selection = new SelectionModel<any>(true, []);

  commissionForm: FormGroup;

  selectedAgents: string;
  agentsList: string[];
  termList: any[];
  agencyID: string;
  selectedAgentOption: string;
  allSelected: boolean;
  isTableExpanded: boolean;
  resolved: boolean = true;
  sending: boolean = false;
  agentID: Number;
  agencyName: string;
  selectedTermOption: string;
  term0: string;
  term1: string;

  eventsSubject: Subject<void> = new Subject<void>();

  parentEvent: EventComponent;

  constructor(
    private dialogService: DialogService,
    private commissionService: CommissionService,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private router: Router,
    private authService: AuthenticationService,
    private userService: UserService,
    private formBuilder: FormBuilder
  ) {
    this.allSelected = true;
    this.isTableExpanded = false;
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(DisputedRequestComponent, {
      maxWidth: "600px",
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(`Dialog result: ${result}`);
    });
  }

  ngOnInit(): void {
    this.parentEvent = new EventComponent();
    this.loadForm();

    // add guard to not display the Commissions screen if you are not an agent

    let paramsObject = window.history.state.parameters;

    if (paramsObject) {
      if (paramsObject.term0) {
        this.selectedTermOption = paramsObject.term0;
        this.term1 = paramsObject.term1;
        this.commissionForm.controls["termCtrl"].setValue(
          this.selectedTermOption
        );
      }
    }

    this.commissionService.getTerms().subscribe(
      (r) => {
        this.termList = r.recordset;
        if (!this.selectedTermOption) {
          this.selectedTermOption = this.termList[0].Name;
        }
      },
      (err) => {
        console.log(err);
      }
    );

    this.commissionForm.controls["termCtrl"].setValue(this.selectedTermOption);

    if (
      this.authService.isAgencyAdmin() ||
      this.authService.isCommissionsUser()
    ) {
      let userInfo = this.authService.getUserInfo();

      this.userService.getAgentAndAgencyID(userInfo.oid).subscribe((data) => {
        this.agentID = data.UserID;
        this.agencyID = data.AgencyID;

        this.commissionService
          .getAgentsByAgencyID(this.agencyID)
          .subscribe((data) => {
            this.agentsList = data;
            this.agencyName = data[0].Agency;
            this.refreshData(null);
          });
      });
    }
  }

  ngOnChanges() {}

  sortData(sort: Sort) {
    if (sort.active && sort.direction !== "") {
      this.dataSource.data.forEach((row: any) => {
        row.isExpanded = false;
      });

      return;
    }
  }

  refreshData(tabParentValue: any): void {
    if (tabParentValue) {
      this.term0 = tabParentValue.term0;
      this.term1 = tabParentValue.term1;
    }

    this.resolved = false;

    setTimeout(() => {
      if (!this.resolved) {
        this.eventClick.emit({ loading: true });
      }
    }, 500);

    this.commissionService
      .getCommissionsNewRequests(this.agencyID)
      .subscribe((data) => {
        this.ELEMENT_DATA = data;
        this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
        this.dataSourceLoaded = new MatTableDataSource(this.ELEMENT_DATA);

        let value = this.selectedTermOption;
        this.dataSource.filter = value.trim();
        this.commissionForm.controls["termCtrl"].setValue(
          this.selectedTermOption
        );

        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.resolved = true;
        this.eventClick.emit({
          loading: false,
          term0: this.selectedTermOption,
        });
      });

    this.parentEvent.term = this.selectedTermOption;

    this.eventsSubject.next();
  }

  spinTimer(): void {}

  loadForm(): void {
    this.commissionForm = this.formBuilder.group({
      termCtrl: new FormControl(""),
    });
  }

  optionChanged(): void {
    this.applyFilterForBothControls();
  }

  optionChanged2(): void {
    this.applyFilterForBothControls();
  }

  applyFilterForBothControls() {
    this.dataSource.data = this.dataSourceLoaded.data;

    this.dataSource.filter = "";

    let dataSourceLocal = this.dataSource;

    if (this.allSelected && Number(this.selectedAgentOption) == 0) {
      let selectedTermOption = "";

      if (this.selectedTermOption) {
        selectedTermOption = this.selectedTermOption.trim().toLowerCase();
      }

      this.dataSource.filter = selectedTermOption;
    } else {
      let selectedTermOption = "";
      let selectedAgentOption = "";

      if (this.selectedTermOption) {
        selectedTermOption = this.selectedTermOption.trim();
      }

      if (this.selectedAgentOption) {
        selectedAgentOption = this.selectedAgentOption;
      }

      [selectedTermOption, selectedAgentOption].map(function (word: string) {
        dataSourceLocal.filter = word.trim().toLowerCase();
        dataSourceLocal.data = dataSourceLocal.filteredData;

        if (dataSourceLocal.paginator) {
          dataSourceLocal.paginator.firstPage();
        }
      });
    }
  }

  applyFilter(filterValue: string) {
    if (this.allSelected && filterValue === "0") {
      let selectedTermOption = "";

      if (this.selectedTermOption) {
        let selectedTermOption = this.selectedTermOption.trim().toLowerCase();
      }

      this.dataSource.filter = selectedTermOption;
    } else {
      this.allSelected = false;
      this.dataSource.filter = filterValue.trim().toLowerCase();
    }
  }

  onSubmitClaim(): void {
    let value = this.selectedAgentOption;

    const numSelected = this.selection.selected.length;

    if (numSelected > 0) {
      const confResult = this.dialogService.openDialog(
        "confirmChanges",
        "Confirm Action",
        "Are you sure you want to submit?",
        "Cancel",
        "Submit"
      );

      confResult.afterClosed().subscribe((dialogRes) => {
        if (dialogRes) {
          // Next steps implement usage with back end
          this.eventClick.emit({ loading: true });
          let RequestIds = [];

          let sel = this.selection.selected;

          sel.forEach(function (value) {
            if (value.CommissionStatusName === "Eligible") {
              RequestIds.push(value.RequestID);
            }
          });

          this.commissionService
            .updateSubmittedRequests(RequestIds, this.agentID)
            .subscribe(
              (res) => {
                if (res) {
                  this.refreshData(null);
                } else {
                  this.dialogService.MessageBox(
                    "Error Updating the commissions status.",
                    "X",
                    5000,
                    "ErrorMessage"
                  );
                  this.resolved = true;
                  this.eventClick.emit({ loading: false });
                }
              },
              (error) => {
                const res = this.dialogService.ErrorDialog(
                  "Server Error",
                  "Sorry, the system is unavailable at the moment.",
                  "Close",
                  "Try Again"
                );
                res.afterClosed().subscribe((dialogResult) => {
                  if (dialogResult) {
                    this.callNext(200);
                  }
                });
              }
            );
        }
      });
    } else {
      const res = this.dialogService.openDialog(
        "confirmChanges",
        "Confirm Action",
        "You have to select at least one application before clicking on the submit button.",
        "Cancel",
        "OK"
      );
    }
  }

  callNext(timeout) {
    setTimeout(() => {
      this.refreshData(null);
    }, timeout);
  }

  onDispute(id: string, commissionStatusName): void {
    let url = "iap/commissions/disputed-request/";

    if (!this.term1) {
      this.term1 = "";
    }

    this.router.navigate([
      url,
      id,
      this.selectedTermOption,
      this.term1,
      this.agencyID,
    ]);
  }

  isAllSelected() {
    if (this.selection && this.dataSource && this.dataSource.data) {
      const numSelected = this.selection.selected.length;
      // const numRows = this.dataSource.data.length;
      const numEligibleRows = this.dataSource.data.filter(
        (row) => row.CommissionStatusName === "Eligible"
      ).length;
      return numSelected === numEligibleRows;
    } else return false;
  }

  toggleAllSelection() {
    console.log("data: ", this.dataSource.data);
    this.allSelected = !this.allSelected; // to control select-unselect
  }

  getRecord(row) {
    this.isTableExpanded = !this.isTableExpanded;

    row.isExpanded = this.isTableExpanded;
  }

  // masterToggle() {
  //   if (this.isAllSelected()) {
  //     this.selection.clear();
  //     return;
  //   }

  //   // this should use the dataSource updated after search
  //   this.dataSource.data.forEach((row: any) => {
  //       this.selection.select(row);
  //   });
  // }

  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
    } else {
      this.dataSource.data.forEach((row: any) => {
        if (row.CommissionStatusName === "Eligible") {
          this.selection.select(row);
        } else {
          this.selection.deselect(row);
        }
      });
    }
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? "deselect" : "select"} all`;
    }
    return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${
      row.position + 1
    }`;
  }

  ExportToExcel() {
    // Create workbook and worksheet
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("ClaimsTable");

    const title = "Agency Commissions Report";

    // Add Row and formatting
    const titleRow = worksheet.addRow([title]);
    titleRow.font = {
      name: "Comic Sans MS",
      family: 4,
      size: 16,
      underline: "double",
      bold: true,
    };

    worksheet.addRow([]);

    let agencyNameTitle = "AgencyName: ";

    if (this.agencyName != undefined) {
      agencyNameTitle += this.agencyName;
    }

    const titleRow2 = worksheet.addRow([agencyNameTitle]);
    titleRow2.font = {
      name: "Comic Sans MS",
      family: 4,
      size: 12,
      underline: "double",
      bold: true,
    };

    const titleRow3 = worksheet.addRow(["Agency ID:" + this.agencyID]);
    titleRow3.font = {
      name: "Comic Sans MS",
      family: 4,
      size: 12,
      underline: "double",
      bold: true,
    };

    worksheet.addRow([]);

    const subTitleRow = worksheet.addRow(["Date : " + new Date()]);
    worksheet.addRow([]);

    const header = [
      "Student Name",
      "Student Number",
      "Application Number",
      "Term",
      "Program Name",
      "Campus",
      "Agent Name",
      "Status Date",
      "Tuition Amount",
      "Commission Amount",
      "Commission Status",
    ];

    // Add Header Row
    const headerRow = worksheet.addRow([]);

    let headerRowNumber = headerRow.number;

    headerRow.font = {
      name: "Comic Sans MS",
      family: 4,
      size: 12,
      underline: "double",
      bold: true,
    };

    let j = 2;

    header.forEach((e) => {
      headerRow.getCell(j).value = e;
      j++;
    });

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFFFF00" },
        bgColor: { argb: "FF0000FF" },
      };
      cell.border = {
        top: { style: "medium" },
        left: { style: "thin" },
        bottom: { style: "thin" },
      };
    });

    var newJSONData = this.dataSource.filteredData.map(function (o) {
      return {
        StudentName: o.StudentName,
        SenecaID: o.SENECA_ID,
        ApplicationID: o.ApplicationID,
        Term: o.Term,
        ProgramDescription: o.ProgramDescription,
        ProgramCampus: o.ProgramCampus,
        AgentName: o.AgentName,
        StatusDate: o.StatusDate,
        TuitionAmount: o.TuitionAmount,
        CommissionAmount: o.CommissionAmount,
        CommissionStatusName: o.CommissionStatusName,
        NotEligibleStatusName: o.NotEligibleStatusName,
      };
    });

    var dataForExcel = [];

    newJSONData.forEach((row: any) => {

      // Use NotEligibleStatusName if it exists, otherwise use CommissionStatusName
      let commissionStatusWithReason = row.NotEligibleStatusName || row.CommissionStatusName;

      const mainRowData = [
        row.StudentName,
        row.SenecaID,
        row.ApplicationID,
        row.Term,
        row.ProgramDescription,
        row.ProgramCampus,
        row.AgentName,
        row.StatusDate,
        row.TuitionAmount,
        row.CommissionAmount,
        commissionStatusWithReason,
      ];
      dataForExcel.push(mainRowData);
    });

    let i = 2;

    dataForExcel.forEach((d) => {
      // Add Data and Conditional Formatting

      const row = worksheet.addRow([]);

      d.forEach((e) => {
        let cell = row.getCell(i);
        cell.value = e;
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
        i++;
      });

      i = 2;

      const qty = row.getCell(4);
      let color = "FF99FF99";

      qty.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: color },
      };
    });

    //worksheet.getColumn(1).width = 40;
    worksheet.getColumn(2).width = 40;  // Student Name
    worksheet.getColumn(3).width = 20;  // Student Number
    worksheet.getColumn(4).width = 25;  // Application Number
    worksheet.getColumn(5).width = 20;  // Term
    worksheet.getColumn(6).width = 40;  // Program Name
    worksheet.getColumn(7).width = 30;  // Campus
    worksheet.getColumn(8).width = 25;  // Agent Name
    worksheet.getColumn(9).width = 20;  // Status Date
    worksheet.getColumn(10).width = 20; // Tuition Amount
    worksheet.getColumn(11).width = 25; // Commission Amount
    worksheet.getColumn(12).width = 55; // Commission Status

    // Footer Row
    const footerRow = worksheet.addRow([]);

    footerRow.getCell(2).fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFCCFFE5" },
    };

    // Merge Cells
    worksheet.mergeCells(`B${footerRow.number}:L${footerRow.number}`);

    let footerRowNumber = footerRow.number;

    for (let k = headerRowNumber; k <= footerRowNumber; k++) {
      let row = worksheet.getRow(k);

      if (k == headerRowNumber) {
        row.getCell(2).border = {
          top: { style: "medium" },
          left: { style: "medium" },
          bottom: { style: "medium" },
          right: { style: "thin" },
        };
        row.getCell(12).border = {
          top: { style: "medium" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "medium" },
        };
      } else if (k == footerRowNumber) {
        row.getCell(2).border = {
          top: { style: "thin" },
          left: { style: "medium" },
          bottom: { style: "medium" },
          right: { style: "thin" },
        };
        row.getCell(12).border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "medium" },
          right: { style: "medium" },
        };
      } else {
        row.getCell(2).border = {
          top: { style: "thin" },
          left: { style: "medium" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
        row.getCell(12).border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "medium" },
        };
      }
    }

    let row = worksheet.getRow(footerRowNumber);
    for (let k = 2; k <= 12; k++) {
      if (k == 2) {
        row.getCell(k).border = {
          top: { style: "thin" },
          left: { style: "medium" },
          bottom: { style: "medium" },
          right: { style: "thin" },
        };
      } else if (k == 12) {
        row.getCell(k).border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "medium" },
          right: { style: "medium" },
        };
      } else
        row.getCell(k).border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "medium" },
          right: { style: "thin" },
        };
    }

    row.getCell(2).border.left.style = "medium";

    // Generate Excel File with given name
    workbook.xlsx.writeBuffer().then((data: any) => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      fs.saveAs(blob, "ClaimsTable.xlsx");
    });
  }

  ExportToPDF() {
    var table = this.CreateHTMLTable();

    var html = htmlToPdfmake(table);

    const documentDefinition = {
      footer: function (
        currentPage: { toString: () => string },
        pageCount: string
      ) {
        return [
          {
            text: "Page " + currentPage.toString() + " of " + pageCount,
            alignment: "center",
          },
        ];
      },
      content: html,
      pageOrientation: "landscape",
      pageMargins: [ 15, 20, 15, 40 ] as [number, number, number, number],
      defaultStyle: {
        fontSize: 11,
      },
    };

    pdfMake.createPdf(documentDefinition as any).open();
  }

  CreateHTMLTable(): any {
    var table = "<table border='1' style='width:100%;word-break:break-word;'>";

    table += "<tr>";
    table += `<td colspan="${11}" >Agency Name: ${this.agencyName}</td>`;
    table += "</tr>";
    table += "<tr>";
    table += `<td colspan="${11}" >Agency ID: ${this.agencyID}</td>`;
    table += "</tr>";
    table += "<tr>";
    table += "<th >Student Name</th>";
    table += "<th >Student Number</th>";
    table += "<th >Application Number</th>";
    table += "<th >Term</th>";
    table += "<th >Program Name</th>";
    table += "<th >Campus</th>";
    table += "<th >Agent Name</th>";
    table += "<th >Status Date</th>";
    table += "<th >Tuition Amount</th>";
    table += "<th >Commision Amount</th>";
    table += "<th >Commision Status</th>";
    table += "</tr>";

    this.dataSource.filteredData.forEach(function (row) {
      table += "<tr>";
      table += "<td>" + row.StudentName + "</td>";
      table += "<td>" + row.SENECA_ID + "</td>";
      table += "<td>" + row.ApplicationID + "</td>";
      table += "<td>" + row.Term + "</td>";
      table += "<td>" + (row.ProgramDescription || '') + "</td>";
      table += "<td>" + (row.ProgramCampus || '') + "</td>";
      table += "<td>" + row.AgentName + "</td>";
      table += "<td>" + row.StatusDate + "</td>";
      table += "<td>" + row.TuitionAmount + "</td>";
      table += "<td>" + row.CommissionAmount + "</td>";
      table += "<td>" + row.CommissionStatusName + "</td>";
      table += "</tr>";
      
      // Add not eligible reason row if exists
      if (row.NotEligibleStatusName) {
        table += "<tr>";
        table += `<td colspan="${11}" style="background-color:#f5f5f5;font-style:italic;">${row.NotEligibleStatusName}</td>`;
        table += "</tr>";
      }
    });

    table += "</table>";

    return table;
  }
}
